import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'pr/'

const initialState = {
    masterData: [],
    voucherDetails: [],
    returnVoucherNo: "",
    addEDLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getVoucherMasterData = createAsyncThunk('PR/gaPR', async (_, thunkAPI) => {

    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getVoucherData = createAsyncThunk('exp/gvd', async (prID, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getPRData/' + prID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const createVoucherMaster = createAsyncThunk('exp/avmd', async (vData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL, vData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const createVoucherDetail = createAsyncThunk('exp/avdd', async (prdData, thunkAPI) => {
    try {

        const result = await axios.post(API_URL + 'detail/', prdData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const getSingleItem = createAsyncThunk('exp/gsi', async (RONO, thunkAPI) => {
    try {

        const result = await axios.get(API_URL + `detail/${RONO}`)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const updateSingleItem = createAsyncThunk('exp/usi', async (edData, thunkAPI) => {
    try {

        const result = await axios.put(API_URL + `detail/${edData.RONO}`, edData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const deleteItem = createAsyncThunk('exp/usi', async (edData, thunkAPI) => {
    try {

        const result = await axios.put(API_URL + `detail/${edData.RONO}`, edData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const prSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.masterData = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getVoucherMasterData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getVoucherMasterData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(getVoucherMasterData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(createVoucherMaster.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createVoucherMaster.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.returnVoucherNo = action.payload
            })
            .addCase(createVoucherMaster.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload.voucherNo
            })
            .addCase(getVoucherData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getVoucherData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.voucherDetails = action.payload.pd
            })
            .addCase(getVoucherData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(createVoucherDetail.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createVoucherDetail.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.voucherDetails = action.payload
            })
            .addCase(createVoucherDetail.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(updateSingleItem.pending, (state) => {
                state.isLoading = true
            })
            .addCase(updateSingleItem.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.voucherDetails = action.payload
            })
            .addCase(updateSingleItem.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = prSlice.actions

export default prSlice.reducer